import type { ReactNode } from 'react'
import { useIncrementalReveal } from '../../hooks/useIncrementalReveal'
import type { Event } from '../../types'

// Renders an event list, revealing more cards as the user scrolls. The heavy
// per-card context (facepiles, interest handlers, lineups) lives in the parent,
// so cards come in via `renderItem` rather than being threaded through props.
export function RevealList({
  items,
  renderItem,
  resetKey,
  batchSize,
  footer,
}: {
  items: Event[]
  renderItem: (event: Event) => ReactNode
  resetKey?: string
  batchSize?: number
  /** Shown once every item is revealed. */
  footer?: ReactNode
}) {
  const { count, sentinelRef } = useIncrementalReveal(items.length, { resetKey, batchSize })
  return (
    <div className="space-y-3">
      {items.slice(0, count).map(renderItem)}
      {count < items.length ? <div ref={sentinelRef} aria-hidden className="h-px" /> : footer}
    </div>
  )
}
